
import { Component } from "@angular/core";
@Component({
    selector: 'shop-about',
  templateUrl: 'about-component.html',
  styleUrls: ['about-component.scss']
})

export class AboutComponent {
  princepipes:boolean = false;

  ngOnInit(){
    const webshop = JSON.parse(sessionStorage.getItem('webshopDetail'));
    if(webshop && webshop.DomainName === "princepipes"){
        this.princepipes = true;
    }

  }
}